<template>
  <div id="psot-card-top">
    <div class="container">
      <div class="avatar"><img class="user-img" :src="getUserInfo.HeadShot" alt="使用者" /></div>
      <div class="name">{{ getUserInfo.NickName }}</div>
      <q-btn class="post-btn" @click="upload" color="lale-primary" text-color="white" label="發佈" />
    </div>
    <!-- 外部模組 tiptap editor -->
    <editor-content class="editor" :editor="editor"></editor-content>
    <!-- url數量大於1就預覽圖片和文字 -->
    <div v-show="contentUrl.length" class="imageBox">
      <img class="urlImg" :src="urlImg" @error="SET_DEFAULT_IMG" />
      <div class="urlTitle">
        <div>{{ urlTitle }}</div>
      </div>
      <div class="urlDescription">
        <div>{{ urlDescription }}</div>
      </div>
    </div>
    <!-- 上傳圖片 -->
    <AddImgBtn v-show="contentUrl.length == 0" ref="AddImgBtn"></AddImgBtn>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { Editor, EditorContent } from 'tiptap';
import AddImgBtn from '@/components/EditPost/AddImgBtn.vue';
export default {
  name: 'EditPostTop',
  components: {
    EditorContent,
    AddImgBtn
  },
  data() {
    return {
      content: '',
      contentUrl: [],
      // initialize editor
      editor: new Editor({
        onUpdate: ({ getHTML }) => {
          this.content = getHTML();
        }
      })
    };
  },
  computed: {
    ...mapGetters(['getUserInfo']),
    ...mapGetters('EditPostModule', ['urlImg', 'urlTitle', 'urlDescription'])
  },
  methods: {
    ...mapMutations('EditPostModule', ['SET_CONTENT', 'SET_DEFAULT_IMG', 'SET_WEB_USER_INFO']),
    ...mapActions('EditPostModule', ['createNewPost', 'parseURL']),
    upload() {
      this.$refs.AddImgBtn.setFile();
      this.createNewPost();
    }
  },
  watch: {
    // 找content裡的url
    content() {
      // 讓HTML Entity可以被連結吃到
      this.content = this.content.replace(/&amp;/, '&');
      this.SET_CONTENT(this.content);
      // 正則表達式找url
      const regex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g;
      if (this.content.match(regex) !== null) {
        this.contentUrl = this.content.match(regex);
        this.parseURL(this.content.match(regex));
      } else {
        this.contentUrl = [];
      }
    }
  }
};
</script>

<style scoped lang="scss">
.ProseMirror {
  outline: none;
}
.q-pa-md {
  padding: 5vw 5vw 0 5vw;
}
.container {
  display: grid;
  grid-template-columns: 20vw auto 25vw;
  height: 70px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.avatar {
  margin-left: 5vw;
  margin-top: 4px;
  align-self: center;
}
.user-img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.name {
  justify-self: left;
  align-self: center;
  font-size: 15px;
  font-weight: bold;
}
.post-btn {
  min-width: 60px;
  align-self: center;
  margin: 0 5vw 0 auto;
}
.editor {
  width: 90vw;
  margin: 5vw auto 0 auto;
}
// 預覽Url圖片和文字
.imageBox {
  width: 90vw;
  display: grid;
  grid-template-columns: 25vw auto;
  grid-template-rows: auto auto;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  margin: 0 auto;
  color: #999;
  min-height: 100px;
  max-height: 110px;
  overflow: hidden;
  .urlImg {
    width: 100%;
    grid-column: 1/2;
    grid-row: 1/3;
    align-self: center;
    height: 100%;
    object-fit: cover;
  }
  .urlTitle {
    grid-column: 2/3;
    grid-row: 1/2;
    margin-left: 2vw;
    font-weight: 600;
    color: #777;
    align-self: center;
    padding: 10px 5px 0px 5px;
    div {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
  .urlDescription {
    grid-column: 2/3;
    grid-row: 2/3;
    margin-left: 2vw;
    align-self: center;
    padding: 0 5px 5px 5px;
    div {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
}
</style>

<style>
.ProseMirror {
  height: 20vh;
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  transition: 0.5s;
  outline: none;
  overflow: auto;
}
.ProseMirror p {
  margin: 0;
  line-height: 1.2;
}
.ProseMirror-focused {
  border: 1px solid #26a69a;
}

@media (min-width: 768px) {
  .ProseMirror {
    width: 60% !important;
    margin: 0 auto !important;
  }

  #add-img-btn {
    width: 54vw !important;
  }

  .avatar {
    margin-left: none;
    align-self: center;
    text-align: right;
    margin-right: 10px;
  }
}
</style>
